import { createContext } from 'react';

const TownAssetsContext = createContext(null);

export default TownAssetsContext;
